import React, { useState } from "react";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { connect } from "react-redux";
import BoundaryMapViewer from "../../components/Boundaries/BoundaryMapViewer";
import CitiesFilterModal from "../../components/Boundaries/CitiesFilterModal";
import Button from "sushiweb/Button";
import { getPath } from "../../utils";
import { FlexContainer, Heading } from "../../constants/assets/containers";

const Boundaries = ({ activeFilters, localitiesList, zonesList }) => {
  const [modalStatus, setModalStatus] = useState(false);

  const allActions = MenuActionsMappings[MenuNames.GEO_BOUNDARIES_DISPLAY];
  return (
    <div>
      <Permission requiredPerms={[allActions.LOCALITY_BOUNDARIES]}>
        <div className="Boundaries-View container">
          <FlexContainer className="mb-20">
            <Heading>Boundaries</Heading>
            <Button
              onClick={() => setModalStatus(!modalStatus)}
              className="sushi-btn"
              appearance="outline"
            >
              {getPath(activeFilters, "city_id", []).length > 0 ? (
                <div className="flex items-center">
                  <span>Cities</span>
                  <h3 className="mb-0 mt-0">{` (${
                    getPath(activeFilters, "city_id", []).length
                  })`}</h3>
                </div>
              ) : (
                "Cities"
              )}
            </Button>
          </FlexContainer>
          <BoundaryMapViewer
            localitiesList={localitiesList}
            zonesList={zonesList}
          />
          {modalStatus && (
            <CitiesFilterModal
              modalState={modalStatus}
              handleClose={() => {
                setModalStatus(false);
              }}
            />
          )}
        </div>
      </Permission>
    </div>
  );
};

function mapStateToProps(state) {
  const { Boundaries } = state;
  return {
    activeFilters: Boundaries.activeFilters,
    localitiesList: Boundaries.localitiesList,
    zonesList: Boundaries.zonesList,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Boundaries);
